
export default {
  data() {
    return {
      bidangCSRChart: [],  // data dari backend
      bidangCSR: [],
      mitra: null,
      tipe: null,
      perusahaan: null,
      indikator: {
        pengajuan: 12,
        diterima: 7,
        ditolak: 3,
        proses: 2
      },

      widgetStatus: {
        total_kegiatan: 0,
        csr_baru: 0,
        dalam_pengerjaan: 0,
        pengerjaan_sebagian: 0,
        selesai: 0
      },
      listPerusahaan: [], // data dari backend
      listBidangUsaha: [], // data dari backend
      columnsPerusahaan: [
        { name: 'nama_perusahaan', label: 'Perusahaan', align: 'left', field: row => row.nama_perusahaan },
        { name: 'jumlah', label: 'Jumlah Partisipasi', align: 'right', field: row => row.jumlah }
      ],

    }
  },
  mounted() {
    const get_profile = JSON.parse(localStorage.profile);

    this.tipe = Number(get_profile.profile.db_csrkonsel);

    this.mitra = {
      id: get_profile._id,
      nama: get_profile.profile.nama,
      username: get_profile.username,
      email: get_profile.email,
      telp: get_profile.profile.telp,
      alamat: get_profile.profile.alamat,
      pic: get_profile.profile.pic,
      file_name: get_profile.profile.file_name // logo perusahaan
    };

    // this.getMitra(get_profile._id);

    this.loadWidgetAdmin();
    this.loadPerusahaan(); // panggil load data perusahaan
    this.loadBidangUsaha(); // panggil load data perusahaan
    this.getBidangCSR(); // panggil load data perusahaan
  },
  methods: {

    async loadPerusahaan() {
      try {
        const res = await fetch(this.$store.state.url.DASHBOARD + 'perusahaanPartisipasi', {
          headers: { authorization: 'kikensbatara ' + localStorage.token }
        });
        const data = await res.json();
        if (data.data) this.listPerusahaan = data.data;
        console.log('Perusahaan Partisipasi:', data.data);
      } catch (err) {
        console.error('Gagal ambil data perusahaan:', err);
      }
    },

    async loadBidangUsaha() {
      try {
        const res = await fetch(this.$store.state.url.DASHBOARD + 'bidangUsaha', {
          headers: { authorization: 'kikensbatara ' + localStorage.token }
        });


        const data = await res.json();

        if (data.data) {
          this.listBidangUsaha = data.data;

        } else {
          console.warn('Backend tidak mengirim data bidang usaha');
        }

      } catch (err) {
        console.error('Gagal ambil data bidang usaha:', err);
      }
    },

    async loadWidgetAdmin() {
      try {
        const res = await fetch(this.$store.state.url.DASHBOARD + "statusAdmin", {
          headers: {
            "authorization": "kikensbatara " + localStorage.token
          }
        });
        const data = await res.json();
        if (data.data) this.widgetStatus = data.data;
        this.$nextTick(() => {
          this.chartPieCSR(); // render chart setelah widgetStatus terisi
        });
        console.log(data);
      } catch (err) {
        console.error('Gagal ambil widget admin:', err);
      }
    },



    chartPieCSR() {
      Highcharts.chart('chartPieCSR', {
        chart: { type: 'pie', backgroundColor: 'transparent' },
        title: { text: 'Status Program CSR' },
        tooltip: { pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>' },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: { enabled: false },
            showInLegend: true
          }
        },
        series: [{
          name: 'Persentase',
          colorByPoint: true,
          data: [
            { name: 'CSR Baru', y: this.widgetStatus.csr_baru, color: '#1e88e5' },
            { name: 'Dalam Pengerjaan', y: this.widgetStatus.dalam_pengerjaan, color: '#ffb300' },
            { name: 'Pengerjaan Sebagian', y: this.widgetStatus.pengerjaan_sebagian, color: '#f57c00' },
            { name: 'Selesai', y: this.widgetStatus.selesai, color: '#43a047' }
          ]
        }]
      });
    },
    getBidangCSR() {
      fetch(this.$store.state.url.DASHBOARD + "bidangCSR", {
        headers: {
          authorization: "kikensbatara " + localStorage.token
        }
      })
        .then(res => res.json())
        .then(res => {
          if (res.data) {
            this.bidangCSR = res.data;
            this.chartByBidangCSR();
          }
        })
        .catch(err => console.error(err));
    },


    chartByBidangCSR() {
      if (!this.bidangCSR || this.bidangCSR.length === 0) return;

      Highcharts.chart('chartByBidangCSR', {
        chart: { type: 'column', backgroundColor: 'transparent' },
        title: { text: 'Pengajuan Berdasarkan Bidang CSR' },
        xAxis: {
          categories: this.bidangCSR.map(b => b.nama_bidang), // <-- ganti nama_bidang -> uraian
          crosshair: true
        },
        yAxis: {
          min: 0,
          title: { text: 'Jumlah Pengajuan' }
        },
        tooltip: {
          shared: true,
          valueSuffix: ' pengajuan'
        },
        plotOptions: {
          column: { colorByPoint: true }
        },
        series: [{
          name: 'Jumlah Pengajuan',
          data: this.bidangCSR.map(b => b.total_pengajuan), // <-- ganti total_pengajuan -> total
          color: '#1e88e5'
        }]
      });
    },


  }
}
